var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "productAnswer" },
    [
      _c("div", { staticClass: "answerTop" }, [
        _c("p", [_vm._v("有什么疑问，问问买过此商品的同学吧～")]),
        _vm._v(" "),
        _c("span", { on: { click: _vm.anonymousFn } }, [_vm._v("我要提问")])
      ]),
      _vm._v(" "),
      _vm.problemList.length
        ? _c(
            "div",
            { staticClass: "questionList" },
            [
              _vm._l(_vm.problemList, function(item, index) {
                return _c(
                  "div",
                  { key: item.problemId, staticClass: "itemBox" },
                  [
                    _c("div", { staticClass: "itemTit" }, [
                      _c("h3", [
                        _c("span", [_vm._v("问")]),
                        _vm._v(_vm._s(item.problem))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "nameOrTime" }, [
                        _vm._v(
                          _vm._s(item.name) + " " + _vm._s(item.createTime)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "replyListBox" }, [
                      item.answers.length
                        ? _c(
                            "ul",
                            { class: { moreShow: _vm.current === index } },
                            _vm._l(item.answers, function(reply, index) {
                              return _c("li", { key: reply.answerId }, [
                                index === 0
                                  ? _c("i", [_vm._v("答")])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "replyInfo" }, [
                                  _c("span", { staticClass: "info" }, [
                                    _vm._v(_vm._s(reply.answer))
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "time" }, [
                                    _vm._v(
                                      _vm._s(reply.name) +
                                        " " +
                                        _vm._s(reply.createTime)
                                    )
                                  ])
                                ])
                              ])
                            }),
                            0
                          )
                        : _c(
                            "div",
                            {
                              staticStyle: {
                                height: "30px",
                                "margin-top": "15px",
                                "font-size": "14px",
                                color: "#999999"
                              }
                            },
                            [_c("span", [_vm._v("暂无回答")])]
                          ),
                      _vm._v(" "),
                      _c("div", { staticClass: "btnBox" }, [
                        item.answers.length > 1
                          ? _c(
                              "div",
                              {
                                staticClass: "moreBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.clickMoreList(index)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.current === index
                                      ? "收起回答"
                                      : "显示更多答复"
                                  )
                                ),
                                _c("i", {
                                  staticClass: "iconfont",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.current === index
                                        ? "&#xe660;"
                                        : "&#xe695;"
                                    )
                                  }
                                })
                              ]
                            )
                          : _c("div"),
                        _vm._v(" "),
                        item.ifAnswer
                          ? _c(
                              "div",
                              {
                                staticClass: "replyBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.toAnswer(
                                      item.problem,
                                      item.problemId
                                    )
                                  }
                                }
                              },
                              [_vm._v("我要回答")]
                            )
                          : _vm._e()
                      ])
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _c("el-pagination", {
                staticStyle: { "margin-bottom": "20px" },
                attrs: {
                  background: "",
                  layout: "prev, pager, next, jumper",
                  "page-size": _vm.pageSize,
                  "current-page": _vm.page,
                  total: _vm.total
                },
                on: { "current-change": _vm.changePage }
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提问",
            visible: _vm.qaDialog,
            width: "30%",
            center: true,
            "before-close": _vm.qaDialogClose
          },
          on: {
            "update:visible": function($event) {
              _vm.qaDialog = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "qaDialogBox" },
            [
              _c("p", { staticClass: "qaInfo" }, [
                _vm._v("您的问题将推送给已购用户，TA们会帮您解答哦～")
              ]),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  placeholder: "请输入内容",
                  resize: "none"
                },
                model: {
                  value: _vm.putQuestion,
                  callback: function($$v) {
                    _vm.putQuestion = $$v
                  },
                  expression: "putQuestion"
                }
              }),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.anonymous,
                    callback: function($$v) {
                      _vm.anonymous = $$v
                    },
                    expression: "anonymous"
                  }
                },
                [_vm._v("匿名提问")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.qaDialog = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addProblem } },
                [_vm._v("发 布")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "回答",
            visible: _vm.replyDialog,
            width: "30%",
            center: true,
            "before-close": _vm.replyDialogClose
          },
          on: {
            "update:visible": function($event) {
              _vm.replyDialog = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "qaDialogBox" },
            [
              _c("p", { staticClass: "qaInfo" }, [
                _vm._v("问：" + _vm._s(_vm.questionTitle))
              ]),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  placeholder: "请输入内容",
                  resize: "none"
                },
                model: {
                  value: _vm.putReply,
                  callback: function($$v) {
                    _vm.putReply = $$v
                  },
                  expression: "putReply"
                }
              }),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.anonymousReply,
                    callback: function($$v) {
                      _vm.anonymousReply = $$v
                    },
                    expression: "anonymousReply"
                  }
                },
                [_vm._v("匿名回答")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.replyDialog = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addAnswer } },
                [_vm._v("发 布")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-77be8f7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-77be8f7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/product/productAnswer.vue
// module id = null
// module chunks = 